import { Route, Routes } from '@angular/router';

import { usuarioPermissaoChildGuard, usuarioPermissaoMatchGuard } from '@guards/usuario-permissao.guard';

import { UsuarioPermissaoEnum, UsuarioPermissaoFlags } from '@utils/enums/UsuarioPermissaoEnums';

import {AberturaOcorrenciaComponent} from './pages/abertura-ocorrencia/abertura-ocorrencia.component';
import {AdicionarContatoComponent} from './pages/adicionar-contato/adicionar-contato.component';
import {AdicionarEnderecoComponent} from './pages/adicionar-endereco/adicionar-endereco.component';
import {AdicionarFilialComponent} from './pages/adicionar-filial/adicionar-filial.component';
import {ConcluirImportacaoDadosBancariosComponent} from './pages/concluir-importacao-dados-bancarios/concluir-importacao-dados-bancarios.component';
import {CondicoesContratacaoComponent} from './pages/condicoes-contratacao/condicoes-contratacao.component';
import {ContratacaoPlanoAvulsoComponent} from './pages/contratacao-rota-inteligente/contratacao-plano-avulso/contratacao-plano-avulso.component';
import {ContratacaoPlanoMensalComponent} from './pages/contratacao-rota-inteligente/contratacao-plano-mensal/contratacao-plano-mensal.component';
import {ContratacaoRotaInteligenteComponent} from './pages/contratacao-rota-inteligente/contratacao-rota-inteligente.component';
import {ContratarRecargaCertaComponent} from './pages/contratar-recarga-certa/contratar-recarga-certa.component';
import {DadosEmpresaComponent} from './pages/dados-empresa/dados-empresa.component';
import {DadosUsuarioRotaInteligenteComponent} from './pages/dados-usuario-rota-inteligente/dados-usuario-rota-inteligente.component';
import {DadosUsuarioComponent} from './pages/dados-usuario/dados-usuario.component';
import {DemonstrativosFaturasComponent} from './pages/demonstrativos-faturas/demonstrativos-faturas.component';
import {DetalhesOcorrenciaComponent} from './pages/detalhes-ocorrencia/detalhes-ocorrencia.component';
import {DevolucoesComponent} from './pages/devolucoes/devolucoes.component';
import {EditarContatoComponent} from './pages/editar-contato/editar-contato.component';
import {EditarEnderecoComponent} from './pages/editar-endereco/editar-endereco.component';
import {EnderecosInativosComponent} from './pages/enderecos-inativos/enderecos-inativos.component';
import {FazerPedidoAvulsoComponent} from './pages/fazer-pedido-avulso/fazer-pedido-avulso.component';
import {FazerPedidoIntegralComponent} from './pages/fazer-pedido-integral/fazer-pedido-integral.component';
import {FazerPedidoComponent} from './pages/fazer-pedido/fazer-pedido.component';
import {GerarPlanilhaDadosComponent} from './pages/gerar-planilha-dados/gerar-planilha-dados.component';
import {GerenciarOcorrenciasComponent} from './pages/gerenciar-ocorrencias/gerenciar-ocorrencias.component';
import {GerenciarPermissoesComponent} from './pages/gerenciar-permissoes/gerenciar-permissoes.component';
import {HistoricoComprasUsuarioComponent} from './pages/historico-compras-usuario/historico-compras-usuario.component';
import {HistoricoImportacoesComponent} from './pages/historico-importacoes/historico-importacoes.component';
import {HomeComponent} from './pages/home/home.component';
import {ImportadorDadosComponent} from './pages/importador-dados/importador-dados.component';
import {ImportarDadosBancariosComponent} from './pages/importar-dados-bancarios/importar-dados-bancarios.component';
import {ListarPedidosCancelarComponent} from './pages/listar-pedidos-cancelar/listar-pedidos-cancelar.component';
import {ListarPedidosDetalhesComponent} from './pages/listar-pedidos-detalhes/listar-pedidos-detalhes.component';
import {ListarPedidosPosPagoComponent} from './pages/listar-pedidos-pos-pago/listar-pedidos-pos-pago.component';
import {ListarPedidosComponent} from './pages/listar-pedidos/listar-pedidos.component';
import {NoticiasDetalhesComponent} from './pages/noticias-detalhes/noticias-detalhes.component';
import {NoticiasComponent} from './pages/noticias/noticias.component';
import {OperadorasComponent} from './pages/operadoras/operadoras.component';
import {PainelManutencoesComponent} from './pages/painel-manutencoes/painel-manutencoes.component';
import {RelatorioGerencialRcComponent} from './pages/relatorio-gerencial-rc/relatorio-gerencial-rc.component';
import {RelatorioRotaComponent} from './pages/relatorio-rota/relatorio-rota.component';
import {ResumoPedidoProcessadoComponent} from './pages/resumo-pedido-processado/resumo-pedido-processado.component';
import {ResumoPedidoComponent} from './pages/resumo-pedido/resumo-pedido.component';
import {TratativasComponent} from './pages/tratativas/tratativas.component';
import {TrocarEmpresaComponent} from './pages/trocar-empresa/trocar-empresa.component';
import {UsuarioBeneficioGerenciarCartoesComponent} from './pages/usuario-beneficio-gerenciar-cartoes/usuario-beneficio-gerenciar-cartoes.component';
import {UsuarioBeneficioComponent} from './pages/usuario-beneficio/usuario-beneficio.component';
import {UsuariosAtivosComponent} from './pages/usuarios-ativos/usuarios-ativos.component';
import {VisualizarErrosImportacaoComponent} from './pages/visualizar-erros-importacao/visualizar-erros-importacao.component';
import { pendingChangesGuard } from '@guards/pending-changes.guard';
import {NaoTemAcessoComponent} from '@pages/nao-tem-acesso/nao-tem-acesso.component';
import {PortalComponent} from '@pages/portal/portal.component';
import {CallbackComponent} from '@pages/callback/callback.component';
import { wso2Guard } from '@guards/wso2.guard';
import {LogoutComponent} from '@pages/logout/logout.component';
import {InformeRendimentosComponent} from '@pages/informe-rendimentos/informe-rendimentos.component';
import {PedidoEstoquePapelComponent} from '@pages/pedido-estoque-papel/pedido-estoque-papel.component';

const rotasAbertas: Route = {
  path: '',
  canActivateChild: [usuarioPermissaoChildGuard],
  canMatch: [usuarioPermissaoMatchGuard],
  children: [
    {
      path: 'portal',
      component: PortalComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioNaoLogado.menuId,
      },
    },
    {
      path: 'callback',
      component: CallbackComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioNaoLogado.menuId,
      },
    },
    {
      path: 'sem-acesso',
      component: NaoTemAcessoComponent,
      canActivate: [wso2Guard]
    }
  ],
};

const rotasProtegidas: Route = {
  path: '',
  canActivate: [wso2Guard],
  canActivateChild: [usuarioPermissaoChildGuard],
  canMatch: [usuarioPermissaoMatchGuard],
  children: [
    {
      path: 'home',
      component: HomeComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: ''
          }
        ]
      },
    },
    {
      path: 'importador-dados',
      component: ImportadorDadosComponent,
      canDeactivate: [pendingChangesGuard],
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Realizar Pedidos',
            url: ''
          },
        ]
      },
    },
    {
      path: 'fazer-pedido-integral',
      component: FazerPedidoIntegralComponent,
      data: {
        title: 'fazer-pedido-integral',
        menuId: UsuarioPermissaoEnum.PedidosIntegral.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Realizar pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Fazer Pedido com Base Atual',
            url: ''
          },
        ]
      },
    },
    {
      path: 'historico-importacoes',
      component: HistoricoImportacoesComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Realizar Pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Histórico de Importações',
            url: ''
          },
        ]
      },
    },
    {
      path: 'tratativas',
      component: TratativasComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Realizar Pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Tratativas',
            url: ''
          },
        ]
      },
    },
    {
      path: 'listar-pedidos',
      component: ListarPedidosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.PedidosListarPedidos.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Listar Pedidos',
            url: ''
          }
        ]
      },
    },
    {
      path: 'listar-pedidos-detalhes',
      component: ListarPedidosDetalhesComponent,
      data: {
        menuId: UsuarioPermissaoEnum.PedidosListarPedidos.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Listar Pedidos',
            url: '/listar-pedidos/'
          },
          {
            label: 'Consulta de pedido',
            url: ''
          }
        ]
      },
    },
    {
      path: 'cancelar-pedidos',
      component: ListarPedidosCancelarComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Listar Pedidos',
            url: '/listar-pedidos/'
          },
          {
            label: 'Cancelamento de Pedidos',
            url: ''
          },
        ]
      },
    },
    {
      path: 'visualizar-erros-importacao',
      component: VisualizarErrosImportacaoComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Realizar pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Visualizar erros de importação',
            url: ''
          }
        ]
      },
    },
    ...[
      { path: 'dados-usuario', lastBreadcrumb: 'Incluir' },
      { path: 'dados-usuario/:idUsuario', lastBreadcrumb: 'Dados do Usuário' },
    ].map(({ path, lastBreadcrumb }) => ({
      path,
      component: DadosUsuarioComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.CadastrosUsuariosDeBeneficio.menuId,
          UsuarioPermissaoEnum.UsuariosDeBeneficioSolicitacao2aVia.menuId],
        flag: [UsuarioPermissaoFlags.Alterar, UsuarioPermissaoFlags.Incluir, UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          { label: 'Início', url: '/home/' },
          { label: 'Cadastro', url: '' },
          { label: 'Usuários de benefícios', url: '/usuario-beneficio/' },
          { label: lastBreadcrumb, url: '' },
        ],
      },
    })),
    {
      path: 'dados-usuario-rota-inteligente/:idUsuario',
      component: DadosUsuarioRotaInteligenteComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.CadastrosUsuariosDeBeneficio.menuId,
          UsuarioPermissaoEnum.UsuariosDeBeneficioSolicitacao2aVia.menuId,
          UsuarioPermissaoEnum.ExclusividadesSugestaoDeRotas.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Usuários de benefícios',
            url: '/usuario-beneficio/'
          },
          {
            label: 'Dados do Usuário',
            url: '/dados-usuario/:idUsuario'
          },
          {
            label: 'Rota Inteligente',
            url: ''
          }
        ]
      },
    },
    {
      path: 'historico-compras-usuario',
      component: HistoricoComprasUsuarioComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.CadastrosUsuariosDeBeneficio.menuId,
          UsuarioPermissaoEnum.UsuariosDeBeneficioSolicitacao2aVia.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Usuários de benefícios',
            url: '/usuario-beneficio/'
          },
          {
            label: 'Dados do Usuário',
            url: '/usuario-beneficio/'
          },
          {
            label: 'Relatório de compras realizadas',
            url: ''
          }
        ]
      },
    },
    {
      path: 'fazer-pedido',
      component: FazerPedidoComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Realizar pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Fazer Pedido Integral',
            url: ''
          },
        ]
      },
    },
    ...['fazer-pedido-avulso/:id', 'fazer-pedido-avulso'].map(path => ({
      path,
      component: FazerPedidoAvulsoComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          { label: 'Início', url: '/home/' },
          { label: 'Cadastro', url: '' },
          { label: 'Usuários de benefícios', url: '/usuario-beneficio/' },
          { label: 'Fazer Pedido Avulso', url: '' },
        ],
      },
    })),
    {
      path: 'resumo-pedido',
      component: ResumoPedidoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Realizar Pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Resumo Pedido',
            url: ''
          }
        ]
      },
    },
    {
      path: 'usuario-beneficio',
      component: UsuarioBeneficioComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.CadastrosUsuariosDeBeneficio.menuId,
          UsuarioPermissaoEnum.UsuariosDeBeneficioSolicitacao2aVia.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir, UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Usuários de benefícios',
            url: ''
          }
        ]
      },
    },
    {
      path: 'devolucoes',
      component: DevolucoesComponent,
      data: {
        menuId:
        UsuarioPermissaoEnum.PedidosDevolucoesDepositoEmContaUsuario.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Devoluções depósito em conta',
            url: ''
          },
        ]
      },
    },
    {
      path: 'noticias',
      component: NoticiasComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Informativo Alelo',
            url: ''
          }
        ]
      },
    },
    {
      path: 'noticias-detalhes',
      component: NoticiasDetalhesComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Informativo Alelo',
            url: '/noticias/'
          },
          {
            label: 'Notícias detalhes',
            url: ''
          }
        ]
      },
    },
    {
      path: 'dados-empresa',
      component: DadosEmpresaComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: ''
          }
        ]
      },
    },
    {
      path: 'adicionar-filial',
      component: AdicionarFilialComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Adicionar Filial',
            url: ''
          }
        ]
      },
    },
    {
      path: 'adicionar-endereco',
      component: AdicionarEnderecoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Adicionar Endereço',
            url: ''
          }
        ]
      },
    },
    {
      path: 'adicionar-contato',
      component: AdicionarContatoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Adicionar Contato',
            url: ''
          }
        ]
      },
    },
    {
      path: 'editar-endereco',
      component: EditarEnderecoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Editar Endereço',
            url: ''
          }
        ]
      },
    },
    {
      path: 'editar-contato/:id',
      component: EditarContatoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Editar Contato',
            url: ''
          }
        ]
      },
    },
    {
      path: 'enderecos-inativos',
      component: EnderecosInativosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresa.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Endereços Inativos',
            url: ''
          }
        ]
      },
    },
    {
      path: 'demonstrativos-faturas',
      component: DemonstrativosFaturasComponent,
      data: {
        menuId: UsuarioPermissaoEnum.PedidosDemonstrativoDeFaturas.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Demonstrativos de fatura',
            url: ''
          },
        ]
      },
    },
    {
      path: 'painel-manutencoes',
      component: PainelManutencoesComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Realizar Pedidos',
            url: '/importador-dados/'
          },
          {
            label: 'Painel de Manutenções',
            url: ''
          },
        ]
      },
    },
    {
      path: 'operadoras',
      component: OperadorasComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Ferramentas',
            url: ''
          },
          {
            label: 'Consultar Operadoras',
            url: ''
          },
        ]
      },
    },
    {
      path: 'usuarios-ativos',
      component: UsuariosAtivosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.RelatoriosRelatorioDeUsuariosAtivos.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Relatórios',
            url: ''
          },
          {
            label: 'Usuários',
            url: ''
          },
        ]
      },
    },
    {
      path: 'usuario-beneficio-gerenciar-cartoes',
      component: UsuarioBeneficioGerenciarCartoesComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Usuário de benefícios',
            url: '/usuario-beneficio/'
          },
          {
            label: 'Gerenciar cartões',
            url: ''
          }
        ]
      },
    },
    {
      path: 'gerenciar-ocorrencias',
      component: GerenciarOcorrenciasComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Gerenciar ocorrências',
            url: ''
          },
        ]
      },
    },
    {
      path: 'detalhes-ocorrencia/:idOcorrenciaPai',
      component: DetalhesOcorrenciaComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Gerenciar ocorrências',
            url: '/gerenciar-ocorrencias/'
          },
          {
            label: 'Detalhes da ocorrência',
            url: ''
          },
        ]
      },
    },
    {
      path: 'nova-ocorrencia',
      component: AberturaOcorrenciaComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Gerenciar ocorrências',
            url: '/gerenciar-ocorrencias/'
          },
          {
            label: 'Nova ocorrência',
            url: ''
          },
        ]
      },
    },
    {
      path: 'listar-pedidos-pos-pago',
      component: ListarPedidosPosPagoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.PedidosLiberarPedidosPosPago.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Listar pedidos pós pago',
            url: ''
          },
        ]
      },
    },
    {
      path: 'condicoes-contratacao',
      component: CondicoesContratacaoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Perfil',
            url: ''
          },
          {
            label: 'Condições de contratação',
            url: ''
          },
        ]
      },
    },
    {
      path: 'contratacao-rota-inteligente',
      component: ContratacaoRotaInteligenteComponent,
      data: {
        menuId: UsuarioPermissaoEnum.ExclusividadesSugestaoDeRotas.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Contratação Rota Inteligente',
            url: ''
          },
        ]
      },
    },
    {
      path: 'contratacao-plano-mensal',
      component: ContratacaoPlanoMensalComponent,
      data: {
        menuId: UsuarioPermissaoEnum.ExclusividadesSugestaoDeRotas.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Contratação Rota Inteligente',
            url: '/contratacao-rota-inteligente/'
          },
          {
            label: 'Contratação Rota Inteligente Mensal',
            url: ''
          },
        ]
      },
    },
    {
      path: 'contratacao-plano-avulso',
      component: ContratacaoPlanoAvulsoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.ExclusividadesSugestaoDeRotas.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Contratação Rota Inteligente',
            url: '/contratacao-rota-inteligente/'
          },
          {
            label: 'Contratação Rota Inteligente Avulso',
            url: ''
          },
        ]
      },
    },
    {
      path: 'relatorio-gerencial-rc',
      component: RelatorioGerencialRcComponent,
      data: {
        menuId: UsuarioPermissaoEnum.RelatoriosGerencialRecargaCerta.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Relatórios',
            url: ''
          },
          {
            label: 'Gerencial Recarga Certa',
            url: ''
          },
        ]
      },
    },
    {
      path: 'relatorio-rota',
      component: RelatorioRotaComponent,
      data: {
        menuId: UsuarioPermissaoEnum.RelatoriosSugestaoDeRota.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Relatórios',
            url: ''
          },
          {
            label: 'Sugestão de Rota',
            url: ''
          },
        ]
      },
    },
    {
      path: 'contratacao-recarga-certa',
      component: ContratarRecargaCertaComponent,
      data: {
        menuId: UsuarioPermissaoEnum.ExclusividadesRecargaCerta.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Exclusividades',
            url: ''
          },
          {
            label: 'Contratação Recarga Certa',
            url: ''
          },
        ]
      },
    },
    {
      path: 'importar-dados-bancarios',
      component: ImportarDadosBancariosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.FerramentasImportacoes.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Ferramentas',
            url: ''
          },
          {
            label: 'Importar Dados Bancários',
            url: ''
          },
        ]
      },
    },
    {
      path: 'concluir-importacao-dados-bancarios',
      component: ConcluirImportacaoDadosBancariosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.FerramentasImportacoes.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Ferramentas',
            url: ''
          },
          {
            label: 'Importar Dados Bancários',
            url: '/importar-dados-bancarios/'
          },
          {
            label: 'Painel de Importações',
            url: ''
          },
        ]
      },
    },
    {
      path: 'gerar-planilha-dados',
      component: GerarPlanilhaDadosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.FerramentasGerarPlanilhaDeDados.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Ferramentas',
            url: ''
          },
          {
            label: 'Gerar planilha de dados',
            url: ''
          },
        ]
      },
    },
    {
      path: 'pedido-estoque-papel',
      component: PedidoEstoquePapelComponent,
      data: {
        menuId: [UsuarioPermissaoEnum.PedidosImportarDadosFazerPedido.menuId,
          UsuarioPermissaoEnum.PedidosIntegral.menuId],
        flag: [UsuarioPermissaoFlags.Imprimir],
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Vale Papel',
            url: ''
          },
        ]
      },
    },
    {
      path: 'resumo-pedido-processado',
      component: ResumoPedidoProcessadoComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Pedidos',
            url: ''
          },
          {
            label: 'Vale Papel',
            url: '/pedido-estoque-papel/'
          },
          {
            label: 'Listar Pedidos',
            url: '/listar-pedidos/'
          },
          {
            label: 'Pedido Processado',
            url: ''
          },
        ]
      },
    },
    {
      path: 'gerenciar-permissoes/:id',
      component: GerenciarPermissoesComponent,
      data: {
        menuId: UsuarioPermissaoEnum.CadastrosDadosDaEmpresaGerenciarPermissoes.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Cadastro',
            url: ''
          },
          {
            label: 'Dados da Empresa',
            url: '/dados-empresa/'
          },
          {
            label: 'Editar Contato',
            url: '/editar-contato/:id'
          },
          {
            label: 'Gerenciar Permissões',
            url: ''
          }
        ]
      },
    },
    {
      path: 'informe-rendimentos',
      component: InformeRendimentosComponent,
      data: {
        menuId: UsuarioPermissaoEnum.UsuarioLogado.menuId,
        breadcrumb: [
          {
            label: 'Início',
            url: '/home/'
          },
          {
            label: 'Relatórios',
            url: ''
          },
          {
            label: 'Informe de rendimentos',
            url: ''
          },
        ]
      },
    }
  ],
};

export const appRoutes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: '/portal'},
  {path: 'login', pathMatch: 'full', redirectTo: '/portal'},
  {path: 'selecionar-empresa', component: TrocarEmpresaComponent, canActivate: [wso2Guard]},
  {path: 'logout', component: LogoutComponent}, 
  rotasAbertas,
  rotasProtegidas,
  {path: '**', pathMatch: 'full', redirectTo: '/home'},
];